import React, { Component, ErrorInfo, ReactNode } from 'react';
import { KatAlert } from '@amzn/katal-react';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false
    };

    public static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('GSLA error:', error, errorInfo);
    }

    public render() {
        if (this.state.hasError) {
            return (
                <KatAlert >
                    <h3>Something went wrong</h3>
                    <p>{this.state.error?.message}</p>
                </KatAlert>
            );
        }

        return this.props.children;
    }
}